// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import '../../snippets/cart-js/cart-js';
import '../../snippets/mini-cart/mini-cart';
import '../../snippets/tooltip/tooltip';
import '../../sections/product-recommendations/product-recommendations';

import '../../sections/header/header';
import '../../sections/footer/footer';
import $ from 'jquery';

// Styles
import './_cart.scss';

const FLYOUT_ITEM_INFO = '.rebuy-cart__flyout-item-info';
const FLYOUT_ITEM_REMOVE_BUTTON = '.rebuy-cart__flyout-item-remove';
const FLYOUT_ITEM_DISCOUNT_MESSAGE = '.rebuy-cart__flyout-item-discount-message';
const YOTPO_REWARDS_PRODUCTS_SECTION = '.page-section--yotpo-rewards-product';
    
//Limits "Plant a tree" products added through Rebuy to only 1.    
document.addEventListener('rebuy:smartcart.ready', () => {
    const Cart = window.Rebuy.Cart;
    
    document.addEventListener('rebuy:cart.change', () =>  {
        const cartItems = Cart.cart.items;

        if (cartItems.length > 0) {
            cartItems.filter(item => item.quantity > 1).forEach((item, index, filteredArray) => {
                if (item?.product_type == "Plant a Tree") {
                    $("#updates_"+item.key).val(1);
                    Cart.setItemQuantity(item, 1);
                    setTimeout(() => document.location.reload(), 1000);
                }
            });
        }
    });

    document.addEventListener("click", function(e){
        const rebuyRemoveItemButton = e.target.closest(FLYOUT_ITEM_REMOVE_BUTTON); // Or any other selector.
      
        if(rebuyRemoveItemButton){

            const itemInfo = rebuyRemoveItemButton.closest(FLYOUT_ITEM_INFO);
            const itemDiscountMessage = itemInfo.querySelector(FLYOUT_ITEM_DISCOUNT_MESSAGE);

            // Check if there is discount applied to this line item
            if (itemDiscountMessage != null) {
                
                // Check if this discount is applied via Yotpo Rewards by checking the discount message added via Shopify Script
                if (itemDiscountMessage.textContent == 'Rewards') {
                    const yotpoRewardsProductSection = document.querySelector(YOTPO_REWARDS_PRODUCTS_SECTION);

                    // Check if the user is currently on the rewards page by detecting the Yotpo Rewards Section - this section is only added to the rewards page. 
                    if (yotpoRewardsProductSection != null) {
                        location.reload(); // Reload the page to update the current reward points
                    }
                }
            }
        }
    });
});